const ProgressLoader = ({
  size = 128,
  dotSize = 30,
  color = "#1878D0",
  speed = 2.5,
}) => {
  const strokeWidth = dotSize;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  const dotCount = Math.round(circumference / (2 * dotSize));

  // For round dots: make dash length very small (just a point)
  const dotLength = 0.1;
  const gapLength = circumference / dotCount - dotLength;

  return (
    <div style={{ display: "inline-block", position: "relative" }}>
      <style>
        {`
          @keyframes rotate {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>

      <svg width={size} height={size}>
        <defs>
          {/* Rotating gradient */}
          <linearGradient
            id="rotatingGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            <stop offset="0%" stopColor={color} stopOpacity="1" />
            <stop offset="50%" stopColor={color} stopOpacity="0.5" />
            <stop offset="100%" stopColor={color} stopOpacity="0.15" />
            <animateTransform
              attributeName="gradientTransform"
              type="rotate"
              from="0 0.5 0.5"
              to="360 0.5 0.5"
              dur={`${speed}s`}
              repeatCount="indefinite"
            />
          </linearGradient>
        </defs>

        {/* Static dots with rotating gradient */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="url(#rotatingGradient)"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={`${dotLength} ${gapLength}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
    </div>
  );
};

export default ProgressLoader;
